import _classCallCheck from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { CONSOLE_LEVELS, GLOBAL_OBJ, fill, severityLevelFromString, safeJoin } from '@sentry/utils';
/** Send Console API calls as Sentry Events */

var CaptureConsole =
/*#__PURE__*/
function () {
  _createClass(CaptureConsole, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'CaptureConsole';
    }
    /**
     * @inheritDoc
     */

    /**
     * @inheritDoc
     */

    /**
     * @inheritDoc
     */

  }]);

  function CaptureConsole() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CaptureConsole);

    this.name = CaptureConsole.id;
    this._levels = options.levels || CONSOLE_LEVELS;
  }
  /**
   * @inheritDoc
   */


  _createClass(CaptureConsole, [{
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (!('console' in GLOBAL_OBJ)) {
        return;
      }

      this._levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        if (!(level in GLOBAL_OBJ.console)) {
          return;
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access


        fill(GLOBAL_OBJ.console, level, function (originalConsoleMethod) {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var hub = getCurrentHub();

            if (hub.getIntegration(CaptureConsole)) {
              hub.withScope(function (scope) {
                scope.setLevel(severityLevelFromString(level));
                scope.setExtra('arguments', args);
                scope.addEventProcessor(function (event) {
                  event.logger = 'console';
                  return event;
                });
                var message = safeJoin(args, ' ');
                var error = args.find(function (arg) {
                  return arg instanceof Error;
                });

                if (level === 'assert') {
                  if (args[0] === false) {
                    message = "Assertion failed: ".concat(safeJoin(args.slice(1), ' ') || 'console.assert');
                    scope.setExtra('arguments', args.slice(1));
                    hub.captureMessage(message);
                  }
                } else if (level === 'error' && error) {
                  hub.captureException(error);
                } else {
                  hub.captureMessage(message);
                }
              });
            } // this fails for some browsers. :(


            if (originalConsoleMethod) {
              originalConsoleMethod.apply(GLOBAL_OBJ.console, args);
            }
          };
        });
      });
    }
  }]);

  return CaptureConsole;
}();

CaptureConsole.__initStatic();

export { CaptureConsole };